import { getCurrencyFromAmount } from './payment'

export const calculatePriceWithPercent = (price: number | string, percentage: number) => {
  const formated = Number(
    String(price)
      .replace(/[^\d.,-]/g, '')
      .replace(/,/g, '')
  )
  if (formated < 0 || percentage < 0) {
    return formated
  }
  const increment = (formated * percentage) / 100

  return Number(formated + increment).toFixed(2)
}

export const convertPrice = (price?: string | number | null) =>
  Math.round((Number(price || 0) + Number.EPSILON) * 100)

export const getFloatPrice = (price: string | number | null) => {
  const symbol = getCurrencyFromAmount(price || 0)
  const num = parseFloat(String(price || 0).replace(symbol, ''))
  return `${symbol}${num.toFixed(2)}`
}

export const removeLeadingZeros = (raw: string): string => {
  if (!raw) return ''

  // Split integer and decimal parts
  const [intPart, decPart] = raw.split('.')

  // Remove leading zeros from integer part, but leave at least "0"
  const newInt = intPart.replace(/^0+(?=\d)/, '')

  // Recombine with decimal if exists
  return decPart !== undefined ? `${newInt}.${decPart}` : newInt
}
